// FLAGS: none
// The note at the top of "Spaces Schedules": it lists only Spaces group sessions, not the expert's whole
// agenda, and points to My sessions for everything else. Closing it is remembered in this browser.
import { useState } from "react";
import { Info, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/** localStorage flag set once the expert closes the note; a display preference, nothing sensitive. */
export const NOTICE_DISMISSED_KEY = "spacesSchedules.noticeDismissed";

const readDismissed = () => {
  try {
    return localStorage.getItem(NOTICE_DISMISSED_KEY) === "true";
  } catch {
    // Storage blocked (private mode, policies): show the note; it costs nothing.
    return false;
  }
};

const HostSignupsNotice = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(readDismissed);

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(NOTICE_DISMISSED_KEY, "true");
    } catch {
      // Not remembered when storage is blocked; the note just returns next visit.
    }
  };

  if (dismissed) return null;

  return (
    <div
      role="note"
      className="relative mb-4 flex gap-3 rounded-lg border border-indigo-100 bg-indigo-50 p-4 pr-10 text-sm text-indigo-900"
    >
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-indigo-700" aria-hidden />
      <div>
        <p>{t("HostSignups.Notice.Body")}</p>
        <Link
          to="/my-sessions"
          className="mt-2 inline-block font-medium text-indigo-800 underline hover:text-indigo-950"
        >
          {t("HostSignups.Notice.MySessionsLink")}
        </Link>
      </div>
      <button
        type="button"
        aria-label={t("HostSignups.Notice.Dismiss")}
        onClick={dismiss}
        className="absolute right-2 top-2 rounded p-1 text-indigo-700 hover:bg-indigo-100 hover:text-indigo-950"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
};

export default HostSignupsNotice;
